import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";
import { studentreportcard, studentview } from "../service/dashboard";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from "moment";

import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// CHART.JS COMPONENT REGISTRATION
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const ReportCard = () => {
    const [rcard, setRCard] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);
    const [progress, setProgress] = useState({ current: 0, total: 0 });
    const [isPdfMode, setIsPdfMode] = useState(false);


const reportCardStyles = useMemo(() => ({
    container: {
        width: isPdfMode ? '210mm' : '100%',
        minHeight: isPdfMode ? '297mm' : 'auto',
        margin: '10px auto',
        padding: isPdfMode ? '20px' : '16px',
        fontFamily: 'Arial, sans-serif',
        fontSize: isPdfMode ? '12px' : '14px',
        backgroundColor: '#fff',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        borderBottom: '2px solid #000',
        paddingBottom: '10px',
        marginBottom: '10px',
    },
    logoContainer: {
        width: '15%',
        textAlign: 'center',
    },
    logo: {
        width: isPdfMode ? '200px' : '100px',
        height: 'auto',
    },

    titleBlock: {
        width: '85%',
        textAlign: 'center',
        lineHeight: '1.2',
    },
    schoolName: {
        fontSize: '18px',
        fontWeight: 'bold',
        textTransform: 'uppercase',
    },
    schoolAddress: {
        fontSize: '14px',
    },
    recordTitle: {
        fontSize: '15px',
        fontWeight: 'bold',
        marginTop: '5px',
        backgroundColor: '#ccc',
        padding: '3px 0',
    },
    infoGridContainer: {
        border: '1px solid #000',
        padding: '5px',
        marginBottom: '10px',
        fontSize: '14px',
        backgroundColor: '#e9e9e9',
    },
    infoRow: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: '2px',
    },
    infoLabel: {
        width: '20%',
        paddingRight: '5px',
        fontWeight: 'normal',
    },
    infoValue: {
        width: '30%',
        fontWeight: 'bold',
    },
    marksTable: {
        width: '100%',
        border: '1px solid #000',
        borderCollapse: 'collapse',
        marginBottom: '10px',
    },
    tableHeadRow: {
        backgroundColor: '#002147',
        color: '#fff',
        fontWeight: 'bold',
    },
    tableCell: {
        border: '1px solid #000',
        padding: '5px',
        fontSize: '14px',
    },
    remarksContainer: {
        border: '1px solid #000',
        marginBottom: '10px',
        padding: '5px',
        backgroundColor: '#ccc',
    },
    gradeKey: {
        display: 'flex',
        justifyContent: 'space-around',
        fontSize: '12px',
        borderBottom: '1px solid #000',
        paddingBottom: '5px',
        marginBottom: '5px',
        flexWrap: 'wrap',
    },
    attendance: {
        display: 'flex',
        justifyContent: 'space-around',
        fontSize: '12px',
        backgroundColor: '#ccc',
    },
    chartContainer: {
        height: isPdfMode ? '250px' : '220px',
        border: '1px solid #000',
        padding: '10px',
        backgroundColor: '#f9f9f9',
        position: 'relative',
    },
    chartPlaceholderText: {
        textAlign: 'center',
        paddingTop: '80px',
        fontSize: '14px',
        color: '#777',
    },
    tableHeadCell: {
        backgroundColor: '#777', // Dark blue
        color: '#ffffff',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    signatureSection: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: isPdfMode ? '60px' : '40px',
        padding: '0 10px',
        alignItems: 'flex-end',
    },
    signatureBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '200px',
    },
    signatureLine: {
        width: '100%',
        // borderTop: '1px solid #000',
        marginTop: '5px',
    },
    signatureLabel: {
        fontSize: '12px',
        fontWeight: 'bold',
    },
    

}), [isPdfMode]);

    function listcard() {
        setRCard([]);
        studentview(localStorage.getItem("UID")).then((res) => {
            const temp = new FormData();
            temp.append("academy_id", localStorage.getItem("academy"));
            temp.append("year_id", res.data.details.academicyear);
            temp.append("class_id", res.data.details.class_id);
            temp.append("section_id", res.data.details.section_id);
            temp.append("student_id", localStorage.getItem("UID"));
            // temp.append("exam_title", res.exam_title);
            studentreportcard(temp).then((res1) => {
                if (res1.status === true) {
                    const details = res1.data.details;

                    if (Array.isArray(details) && details.length > 0) {
                        const lastItem = details[details.length - 1];
                        setRCard([lastItem]); // ✅ keep it as array
                    } else {
                        setRCard([]); // fallback
                    }

                }
            });
        });

    }

    useEffect(() => {
        listcard();
    }, []);

    // --- Utility Functions ---
    function errorhandle(ev) {
        ev.target.src = require("../assets/images/logo/logo.png");
        ev.target.onerror = null;
    }

    const getGrade = (mark, maxMark) => {
        if (!mark || !maxMark) return '-';
        const percentage = (mark / maxMark) * 100;

        if (percentage >= 90) return 'A';
        if (percentage >= 80) return 'B';
        if (percentage >= 70) return 'C';
        if (percentage >= 60) return 'D';
        if (percentage >= 35) return 'E';
        return 'F';
    };


    const getTotalMaxMarks = (subjects) => {
        return subjects.reduce((sum, data) => (
            sum + parseInt(data.total_theory_marks || 0) + parseInt(data.total_practical_marks || 0)
        ), 0);
    };

    const getTotalObtainedMarks = (subjects) => {
        return subjects.reduce((sum, data) => (
            sum + parseInt(data.student_theory_mark || 0) + parseInt(data.student_practical_mark || 0)
        ), 0);
    };

    const getSubjectMaxMark = (data) => {
        return parseInt(data.total_theory_marks || 0) + parseInt(data.total_practical_marks || 0);
    };

    const getSubjectObtainedMark = (data) => {
        return parseInt(data.student_theory_mark || 0) + parseInt(data.student_practical_mark || 0);
    };


    // --- PDF Download Logic ---
    const downloadReport = async () => {
        setIsDownloading(true);
        setIsPdfMode(true);
        setProgress({ current: 0, total: rcard.length });

        // Initialize PDF with A4 dimensions
        const pdf = new jsPDF("p", "mm", "a4");
        const reportCards = document.querySelectorAll("#report-card");

        for (let i = 0; i < reportCards.length; i++) {
            const element = reportCards[i];

            // Small delay to ensure the chart is fully rendered before capture
            await new Promise((resolve) => setTimeout(resolve, 300));

            const canvas = await html2canvas(element, {
                scale: 3,
                useCORS: true,
                scrollY: -window.scrollY,
                backgroundColor: "#ffffff"
            });

            const imgData = canvas.toDataURL("image/jpeg", 0.9); // Use 0.9 quality
            const imgProps = pdf.getImageProperties(imgData);

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

            if (i !== 0) {
                pdf.addPage();
            }

            pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight, undefined, "FAST");
            setProgress({ current: i + 1, total: reportCards.length });
        }

        pdf.save("Report_Cards.pdf");
        setIsPdfMode(false);
        setIsDownloading(false);
    };


    // --- CHART DATA PREPARATION FUNCTION (Bar Chart) ---
    const prepareChartData = (subjects) => {
        const labels = subjects.map(s => s.subject_name);
        const maxScores = subjects.map(s => getSubjectMaxMark(s));
        const obtainedScores = subjects.map(s => getSubjectObtainedMark(s));

        // Find the highest score to set the y-axis max
        const maxMarkValue = Math.max(...maxScores) + 10; // Add buffer

        const chartData = {
            labels,
            datasets: [
                {
                    label: 'Maximum Score',
                    data: maxScores,
                    backgroundColor: 'rgba(75, 192, 192, 0.8)',
                    borderColor: 'rgb(75, 192, 192)',
                    borderWidth: 1,
                },
                {
                    label: 'Total Marks Obtained',
                    data: obtainedScores,
                    backgroundColor: 'rgba(255, 99, 132, 0.8)',
                    borderColor: 'rgb(255, 99, 132)',
                    borderWidth: 1,
                },
            ],
        };

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'top',
                },
                title: {
                    display: true,
                    text: 'Performance Analysis Chart',
                },
            },
            scales: {
                y: {
                    beginAtZero: true,
                    max: maxMarkValue,
                    title: {
                        display: false,
                        text: 'Marks'
                    }
                },
                x: {
                    title: {
                        display: false,
                        text: 'Subjects'
                    }
                }
            }
        };

        return { chartData, options };
    };



    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

                <div className="moreheading">
                    <Row className="row-sm">
                        <Col xs={7} className="text-left align-self-end">
                            <h4 className="morehead-text">My Report Card</h4>
                        </Col>

                        <Col xs={5} className="text-right align-self-end">

                            <Link
                                to={"/dashboard"}
                                className="btn-outline-success red-btn btn-sm"
                            >
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>

                    </Row>
                    
                </div>

                {rcard.map((item, i) => {
                    const totalMaxMarks = getTotalMaxMarks(item.subjects);
                    const totalObtainedMarks = getTotalObtainedMarks(item.subjects);
                    const { chartData, options } = prepareChartData(item.subjects);

                    return (
                        // The main container for the single report card
                        <div id="report-card" key={i} className="report-card-container" style={reportCardStyles.container}>

                            {/* Header Section */}
                            <div className="report-card-header" style={reportCardStyles.header}>
                                <div style={reportCardStyles.logoContainer}>
                                    {item.logo !== "" && (
                                        <img
                                            src={item.path + item.logo}
                                            alt="Academy Logo"
                                            onError={errorhandle}
                                            style={reportCardStyles.logo}
                                        />
                                    )}
                                    {item.logo === "" && (
                                        <img
                                            src={require("../assets/images/logo/logo.png")}
                                            alt="Academy Logo"
                                            style={reportCardStyles.logo}
                                        />
                                    )}
                                </div>
                                <div style={reportCardStyles.titleBlock}>
                                    <div style={reportCardStyles.schoolName}>{item.academy_name}</div>
                                    <div style={reportCardStyles.schoolAddress}>{item.address}</div>
                                    <div style={reportCardStyles.recordTitle}>
                                        Record of Academic Performance - {item.exam_title.toUpperCase()}, {item.academic_year}
                                    </div>
                                </div>
                            </div>

                            {/* Student Info Grid */}
                            <div style={reportCardStyles.infoGridContainer}>
                                <div style={reportCardStyles.infoRow}>
                                    <div style={reportCardStyles.infoLabel}>Name:</div>
                                    <div style={reportCardStyles.infoValue}><strong>{item.name}</strong></div>
                                    <div style={reportCardStyles.infoLabel}>Username:</div>
                                    <div style={reportCardStyles.infoValue}><strong>{item.username}</strong></div>
                                </div>
                                <div style={reportCardStyles.infoRow}>
                                    <div style={reportCardStyles.infoLabel}>Father's Name:</div>
                                    <div style={reportCardStyles.infoValue}><strong>{item.father_name}</strong></div>
                                    <div style={reportCardStyles.infoLabel}>Class / Div:</div>
                                    <div style={reportCardStyles.infoValue}><strong>{item.class_name} - {item.section_name}</strong></div>
                                </div>
                                <div style={reportCardStyles.infoRow}>
                                    <div style={reportCardStyles.infoLabel}>Mother's Name:</div>
                                    <div style={reportCardStyles.infoValue}><strong>{item.mother_name}</strong></div>
                                    <div style={reportCardStyles.infoLabel}></div>
                                    <div style={reportCardStyles.infoValue}></div>
                                </div>
                                <div style={reportCardStyles.infoRow}>
                                    <div style={reportCardStyles.infoLabel}>Adm No:</div>
                                    <div style={reportCardStyles.infoValue}><strong>{item.admission_number}</strong></div>
                                    <div style={reportCardStyles.infoLabel}>DOB:</div>
                                    <div style={reportCardStyles.infoValue}><strong>{moment(item.dob).format("DD/MM/YYYY")}</strong></div>
                                </div>

                            </div>


                            {/* Subject Marks Table */}
                            <div style={{ width: '100%', overflowX: 'auto' }}>
                                <table style={reportCardStyles.marksTable} cellSpacing="0" cellPadding="5">
                                    <thead>
                                        <tr>
                                            <th style={{ ...reportCardStyles.tableCell, ...reportCardStyles.tableHeadCell, width: '10%' }}>Sl.No</th>
                                            <th style={{ ...reportCardStyles.tableCell, ...reportCardStyles.tableHeadCell, width: '25%' }}>Subject</th>
                                            <th style={{ ...reportCardStyles.tableCell, ...reportCardStyles.tableHeadCell, width: '20%' }}>Max Score</th>
                                            <th style={{ ...reportCardStyles.tableCell, ...reportCardStyles.tableHeadCell, width: '20%' }}>Marks Obtained</th>
                                            <th style={{ ...reportCardStyles.tableCell, ...reportCardStyles.tableHeadCell, width: '10%' }}>Total</th>
                                            <th style={{ ...reportCardStyles.tableCell, ...reportCardStyles.tableHeadCell, width: '10%' }}>Grade</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {item.subjects.map((data, j) => {
                                            const subjectMax = getSubjectMaxMark(data);
                                            const subjectObtained = getSubjectObtainedMark(data);
                                            const grade = getGrade(subjectObtained, subjectMax);

                                            return (
                                                <tr key={j}>
                                                    <td style={{ ...reportCardStyles.tableCell, textAlign: 'center' }}>{j + 1}</td>
                                                    <td style={reportCardStyles.tableCell}>{data.subject_name}</td>
                                                    <td style={{ ...reportCardStyles.tableCell, textAlign: 'center' }}>{subjectMax}</td>
                                                    <td style={{ ...reportCardStyles.tableCell, textAlign: 'center' }}>{subjectObtained}</td>
                                                    <td style={{ ...reportCardStyles.tableCell, textAlign: 'center', fontWeight: 'bold' }}>{subjectObtained}</td>
                                                    <td style={{ ...reportCardStyles.tableCell, textAlign: 'center', fontWeight: 'bold' }}>{grade}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            {/* Grade Key / Remarks */}
                            <div style={reportCardStyles.remarksContainer}>
                                <div style={reportCardStyles.gradeKey}>
                                    <span>A = 90 - 100</span>
                                    <span>B = 80 - 89</span>
                                    <span>C = 70 - 79</span>
                                    <span>D = 60 - 69</span>
                                    <span>E = 35 - 59</span>
                                    <span>F = 1 - 34</span>
                                </div>
                                <div style={reportCardStyles.attendance}>
                                    <span style={{ fontWeight: 'bold' }}>Attendance </span>
                                    <span>No of working days: {item.working_days || 0}</span>
                                    <span>No of days present: {item.present_days || 0}</span>
                                </div>
                            </div>

                            {/* BAR CHART Implementation */}
                            <div style={reportCardStyles.chartContainer}>
                                {item.subjects.length > 0 ? (
                                    <Bar data={chartData} options={options} />
                                ) : (
                                    <div style={reportCardStyles.chartPlaceholderText}>No subject data available to generate chart.</div>
                                )}
                            </div>

                            <div style={{ marginTop: '10px', fontSize: '12px', paddingLeft: '5px' }}>
                                <span style={{ marginRight: '20px' }}><strong>Total Marks Obtained:</strong> {totalObtainedMarks}</span>
                                <span><strong>Maximum Marks:</strong> {totalMaxMarks}</span>
                            </div>

                            <div style={{ marginTop: '15px', fontSize: '14px', paddingLeft: '5px' }}>
                                <span style={{ marginRight: '20px' }}><strong>Remarks:</strong> </span>
                            </div>

                            <div style={{ fontSize: '12px', paddingLeft: '5px', paddingTop: '5px' }}>
                                Issued On:
                                {/* {moment().format("DD-MM-YYYY")}  borderTop: '1px solid #ccc', marginTop: '15px',  */}
                            </div>

                            {/* Signature Section */}
                            <div style={reportCardStyles.signatureSection}>
                                <div style={reportCardStyles.signatureBlock}>
                                    <div style={reportCardStyles.signatureLabel}>Principal Signature</div>
                                    <div style={reportCardStyles.signatureLine}></div>
                                </div>
                                <div style={reportCardStyles.signatureBlock}>
                                    <div style={reportCardStyles.signatureLabel}>Teacher Signature</div>
                                    <div style={reportCardStyles.signatureLine}></div>
                                </div>
                                <div style={{ flex: 1 }}></div> {/* Spacer */}
                                <div style={reportCardStyles.signatureBlock}>
                                    <div style={reportCardStyles.signatureLabel}>Parent Signature</div>
                                    <div style={reportCardStyles.signatureLine}></div>
                                </div>
                            </div>


                        </div>
                    )
                })}
                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                        <button
                            className="btn btn-success"
                            onClick={downloadReport}
                            disabled={isDownloading || rcard.length === 0}
                        >
                            {isDownloading ? "Generating PDF..." : "Download Report Card"}
                        </button>
                    </div>
            </div>

            <Footer />
        </div>
    );
};



export default ReportCard;
